<div class="wrapper a-{{align}}">
	<div
		*ngIf="(!controlNameToValidate && form?.errors) || (controlNameToValidate && form?.get(controlNameToValidate)?.touched && form?.get(controlNameToValidate)?.errors)"
		class="message">
		<ng-content>
		</ng-content>
	</div>
</div>
